import { isMembershipType } from './isMembershipType';

export const isMembershipNormal = (
  membership:
    | { memberType: 'admin' | 'normal' }
    | { memberType: 'admin' | 'normal' | 'observer' },
): boolean => isMembershipType(membership, 'normal');
